export const LARGE_FIELD = {
  fontSize: 20,
  height: 60
};
